import { CopyUserGroups, CopyUserGroupsResult, CreateUserGroup, UpdateUserGroup } from '../models/userGroup';
import apiClient from './api';

export const createUserGroup = async (userGroup: CreateUserGroup) => {
    const response = await apiClient.post('/userGroup', userGroup);
    return response.data;
}

export const getUserGroups = async () => {
    const response = await apiClient.get('/userGroup');
    return response.data;
}

export const getUserGroupsByUser = async (userID: number) => {
    const response = await apiClient.get(`/userGroup/user/${userID}`);
    return response.data;
}

export const getUserGroupsByModule = async (moduleID: number) => {
    const response = await apiClient.get(`/userGroup/module/${moduleID}`);
    return response.data;
}

export const getUserGroupsByModuleAndOrganizationID = async (moduleID: number, organizationID: number) => {
    let params = new URLSearchParams();

    params.append('moduleID', moduleID.toString());
    params.append('organizationID', organizationID.toString());

    const response = await apiClient.get(`/userGroup/organization?${params.toString()}`);
    return response.data;
}

export const updateUserGroup = async (userGroup: UpdateUserGroup) => {
    const response = await apiClient.put('/userGroup', userGroup);
    return response.data;
}

export const copyUserGroups = async (copy: CopyUserGroups): Promise<CopyUserGroupsResult> => {
    const response = await apiClient.post('/userGroup/copy', copy);
    return response.data;
}

export const deleteUserGroup = async (userGroupID: number) => {
    const response = await apiClient.delete(`/userGroup/${userGroupID}`);
    return response.data;
}

